import Vue from 'vue'
import Vuex from 'vuex'

import states from './states'
import actions from './action'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: states,
  mutations: mutations,
  actions: actions
})



export default store



// WEBPACK FOOTER //
// ./src/store/store.js